class MinimumBreakTimeRules{
    constructor(activatedRules){
        this.isRule14 = (activatedRules.Regel14 < 2);
        this.isRule15 = (activatedRules.Regel15 < 2);
        this.isRule32 = (activatedRules.Regel32 < 2);
        this.minBreakRule14 = activatedRules.Regel14min;
        this.minBreakRule15 = activatedRules.Regel15min;
        this.minBreakRule32 = activatedRules.Regel32min;
    }

    calcSubtractionFromHourRules(shiftTime, breakTime) {

        let hours6 = 6 * 60;
        let hours8 = 8 * 60;
        let hours9 = 9 * 60;

        if (shiftTime > hours9 && this.isRule15) {
            if(breakTime <= this.isRule15) {
                return this.minBreakRule15 - breakTime;
            }
        }
        else if (shiftTime > hours8 && this.isRule32) {
            if(breakTime <= this.isRule32) {
                return this.minBreakRule32 - breakTime;
            }
        }
        else if (shiftTime > hours6 && this.isRule14) {
            if (breakTime <= this.isRule14) {
                return this.minBreakRule14 - breakTime;
            }
        }
        return 0;
    }
}